var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _jsReanimated = _interopRequireDefault(require("../js-reanimated"));
var _PlatformChecker = require("../PlatformChecker");
var _NativeReanimated = require("./NativeReanimated");
var _default = exports.default = (0, _PlatformChecker.shouldBeUseWeb)() ? _jsReanimated.default : new _NativeReanimated.NativeReanimated();
